<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="scenic-manage-tab" data-bs-toggle="pill" data-bs-target="#scenic-manage"
            type="button" role="tab" aria-controls="scenic-manage" aria-selected="true"> 景區設定 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="scenic-parking-tab" data-bs-toggle="pill" data-bs-target="#scenic-parking" 
            type="button" role="tab" aria-controls="scenic-parking" aria-selected="false">景區車位設定 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="estimate_people-tab" data-bs-toggle="pill" data-bs-target="#estimate_people" 
            type="button" role="tab" aria-controls="estimate_people" aria-selected="false">車流換算人流設定 </button>
        </li>

        <li class="nav-item" role="presentation">
          <button class="nav-link" id="public_place-tab" data-bs-toggle="pill" data-bs-target="#public_place" 
            type="button" role="tab" aria-controls="public_place" aria-selected="false">設備地點設定 </button>
        </li>

        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link" id="license-plate-tab" data-bs-toggle="pill" data-bs-target="#license-plate" 
            type="button" role="tab" aria-controls="license-plate" aria-selected="false">車牌辨識排除設定 </button>
        </li> -->
      </ul>

      
      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <scenic-area-manage></scenic-area-manage>
        <scenic-area-parking-manage></scenic-area-parking-manage>
        <scenic-area-estimate-people></scenic-area-estimate-people>
        <scenic-area-estimate-people></scenic-area-estimate-people>
        <public-place-manage></public-place-manage>
        <!-- <license-plate-manage></license-plate-manage> -->

      </div>
    </div>
  </main>
</template>

<script>
import scenicAreaManage from './scenicAreaManage.vue';
import scenicAreaParkingManage from './scenicAreaParkingManage.vue';
import scenicAreaEstimatePeople from './scenicAreaEstimatePeople.vue';
import publicPlaceManage from './publicPlaceManage.vue';
// import licensePlateManage from './licensePlateMange';





export default {
  components: { scenicAreaManage, scenicAreaParkingManage, scenicAreaEstimatePeople,publicPlaceManage,},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {

  },
  mounted() {

  },
};
</script>

<style>
</style>
